import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bf-modal bf-modal--has-sections bf-modal-course-appointments"
}
const _hoisted_2 = { class: "bf-modal__section bf-bg-primary" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script mb-3" }, "Kurstermine", -1)
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "bf-modal-course-appointments__name" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('' /* @TODO: centralize */) + " ")
const _hoisted_10 = { class: "me-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-label": 'Kursbeschreibung'
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Kursbeschreibung", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "bf-modal-course-appointments__horizontal-divider mx-2" }, "–", -1)
const _hoisted_16 = { class: "bf-modal-course-appointments__mode text-nowrap" }
const _hoisted_17 = {
  key: 0,
  class: "bf-modal-course-appointments__appointments-count"
}
const _hoisted_18 = {
  key: 1,
  class: "bf-modal-course-appointments__appointments-next"
}
const _hoisted_19 = { class: "bf-modal__section bf-modal__section--no-padding" }
const _hoisted_20 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_AppointmentsCalendar = _resolveComponent("AppointmentsCalendar")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shown,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shown) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.course)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "modal-close-button",
                    "aria-label": "Schließen",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                  }, _hoisted_7)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Popper, {
                  hover: true,
                  arrow: true
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _hoisted_12,
                      _hoisted_13,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptionLines, (line) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: line }, [
                          _createElementVNode("span", null, _toDisplayString(line), 1),
                          _hoisted_14
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createElementVNode("b", _hoisted_10, _toDisplayString(_ctx.course.course_type.name), 1),
                      _hoisted_11
                    ])
                  ]),
                  _: 1
                }),
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.course.mode === 0 ? 'Offener Kurs' : 'Geschlossener Kurs'), 1)
              ]),
              (_ctx.appointments !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.appointments.length) + " kommende Termine ", 1))
                : _createCommentVNode("", true),
              (_ctx.appointments !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Nächster Termin: " + _toDisplayString(_ctx.appointments.length > 0 ? _ctx.formatDatetimeWithDayLabel(_ctx.appointments[0].start) : '–'), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.loadingAppointments)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                : (_openBlock(), _createBlock(_component_AppointmentsCalendar, {
                    key: 1,
                    appointments: _ctx.appointmentsWithCourse || []
                  }, null, 8, ["appointments"]))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}